import { render, staticRenderFns } from "./VideoWithTool.vue?vue&type=template&id=7b19947a&scoped=true"
import script from "./VideoWithTool.vue?vue&type=script&lang=js"
export * from "./VideoWithTool.vue?vue&type=script&lang=js"
import style0 from "./VideoWithTool.vue?vue&type=style&index=0&id=7b19947a&prod&lang=less"
import style1 from "./VideoWithTool.vue?vue&type=style&index=1&id=7b19947a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b19947a",
  null
  
)

export default component.exports